<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>
    <!-- Form -->
    <form @submit.prevent="store" class="w-full h-full">
        <div class="flex flex-wrap mb-6">
            <control type="hidden" v-model="comboards.id" :hasError="!!errors.id" id="id" />
        </div>
        <div class="flex flex-wrap mx-3 mb-2">
            <field :label="'Title'" class="w-full md:ml-2 md:mr-2 mb-2 md:mb-0">
                <control required type="text" name="title" :placeholder="$t('comboard.placeholder.title')"
                    v-model="comboards.title" :hasError="!!errors.title">
                </control>
            </field>
        </div>
        <div class="flex flex-wrap mx-3 mb-2">
            <field :label="'Show Time'" class="w-full md:ml-2 md:mr-2 mb-2 md:mb-0">
                <datepicker :enableTimePicker="true" v-model="comboards.show_date" :hasError="!!errors.show_date"
                    required name="date">
                </datepicker>
            </field>
        </div>
        <div class="flex flex-wrap mx-4 mb-2">
            <field :label="'Is Priority'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="radio" required name="priority" v-model="comboards.is_priority"
                    :hasError="!!errors.is_priority" :options="{ true: 'Yes', false: 'No' }"
                    style="display: flex; flex-wrap: nowrap; gap: 1.25rem">
                </check-radio-picker>
            </field>
        </div>
        <div class="flex flex-wrap mx-3 mb-2">
            <field :label="'Category'" class="w-full form-select md:ml-2 mb-2 md:mb-0" :hasError="errors.category">
                <control :options="categoryList" :placeholder="'Select Category'"
                    v-model="comboards.comboard_category_id" :hasError="!!errors.comboard_category_id" required
                    id="category">
                </control>
            </field>
        </div>
        <div class="flex flex-wrap mx-4 mb-2">
            <field :label="'Information'" class="form-col-input-full" :hasError="errors.info">

                <vue-editor :editorToolbar="customToolbar" v-model="comboards.info" />
            </field>
        </div>
        <div class="flex flex-wrap mx-4 mb-2">
            <field :label="'Is Event'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="switch" name="isEvent" v-model="customElementsForm.is_event"
                    :hasError="!!errors.is_event" :options="{ 1: 'Yes' }">
                </check-radio-picker>
            </field>
        </div>
        <div class="flex flex-wrap md:flex-nowrap mx-4">
            <field :label="'Start Time'" class="w-full md:mr-2"
                v-if="customElementsForm.is_event === 'true' || customElementsForm.is_event == true"
                :hasError="errors.datetime_1">
                <datepicker required v-model="comboards.datetime_1" :enableTimePicker="false"
                    :hasError="!!errors.datetime_1" name="datetime_1">
                </datepicker>
            </field>
            <field :label="'End Time'" class="w-full"
                v-if="customElementsForm.is_event === 'true' || customElementsForm.is_event == true"
                :hasError="errors.datetime_2">
                <datepicker required v-model="comboards.datetime_2" :hasError="!!errors.datetime_2"
                    :enableTimePicker="false" name="datetime_2">
                </datepicker>
            </field>
        </div>
        <div class="flex flex-wrap md:flex-nowrap mx-4 mb-5">
            <field :label="'To Parents'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="switch" name="toParent" v-model="customElementsFormParent.to_parent"
                    :hasError="!!errors.to_parent" :options="{ 1: 'Yes' }">
                </check-radio-picker>
            </field>
            <field :label="'To Students'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="switch" name="toStudent" v-model="customElementsFormStudent.to_student"
                    :hasError="!!errors.to_student" :options="{ 1: 'Yes' }">
                </check-radio-picker>
            </field>
        </div>
        <div class="flex flex-wrap md:flex-nowrap mx-4 mb-5">
            <field :label="'To Teacher'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="switch" name="toTeacher" v-model="customElementsFormTeacher.to_teacher"
                    :hasError="!!errors.to_teacher" :options="{ 1: 'Yes' }">
                </check-radio-picker>
            </field>
              <field :label="'To Employee'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="switch" name="toEmployee" v-model="customElementsFormEmployee.to_employee"
                    :hasError="!!errors.to_employee" :options="{ 1: 'Yes' }">
                </check-radio-picker>
            </field>
        </div>

        <div class="flex flex-wrap md:flex-nowrap mx-4 mb-2">
            <field :label="'Is Recalled'" class="w-full md:ml-2 mb-2 md:mb-0">
                <check-radio-picker type="radio" required name="recalled" v-model="comboards.is_recalled"
                    :hasError="!!errors.is_recalled" :options="{ true: 'Yes', false: 'No' }"
                    style="display: flex; flex-wrap: nowrap; gap: 1.25rem">
                </check-radio-picker>
            </field>
            <field :label="'Recall Time'" v-if="comboards.is_recalled === 'true' || comboards.is_recalled == true"
                class=" w-full md:ml-2 md:mr-2 mb-2 md:mb-0">
                <Datepicker required v-model="comboards.recall_time" :hasError="!!errors.recall_time"
                    :enableTimePicker="true" name="recall_time">
                </Datepicker>
            </field>
        </div>

        <div class="flex flex-wrap mx-3 mb-6">
            <field :label="'Reason'" v-if="comboards.is_recalled === 'true' || comboards.is_recalled == true"
                class="form-select w-full md:ml-2 mb-2 md:mb-0">
                <control required type="text" name="reason" :placeholder="$t('comboard.placeholder.reason')"
                    v-model="comboards.reason" :hasError="!!errors.reason">
                </control>
            </field>
        </div>

        <div class="flex flex-wrap mx-3 mb-6">
            <field :label="'Link URL'" class="form-select w-full md:ml-2 mb-2 md:mb-0" :hasError="errors.authority">
                <control type="text" :placeholder="$t('comboard.placeholder.url')" v-model="comboards.link_url"
                    :hasError="!!errors.link_url" />
            </field>
        </div>

        <div style="margin-left: 1.25rem; display: flex;">
            <jb-button style="margin-bottom: 10px !important; margin-right: 5px;" type="submit" color="info"
                label="Submit"></jb-button>
            <jb-button style="margin-bottom: 10px !important;" type="reset" color="info" outline
                label="Reset"></jb-button>
        </div>
    </form>
</template>

<script>
/* eslint-disable */
import Editor from '@tinymce/tinymce-vue'
import { VueEditor } from "vue3-editor"
import Datepicker from '@vuepic/vue-datepicker'
import Field from '@/components/Field'
import Control from '@/components/Control'
import JbButton from '@/components/JbButton'
import CheckRadioPicker from '@/components/CheckRadioPicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import { useStore } from 'vuex'
import { getCategoryList } from '@/composables/global'
import axios from 'axios'
import { watch, watchEffect, onMounted, onBeforeMount, ref, reactive } from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import RecipientsForm from '@/views/comboards/comboard/RecipientsForm.vue'
export default {
    name: 'ClassForm',
    components: {
        Loading,
        Datepicker,
        Editor,
        Field,
        Control,
        JbButton,
        CheckRadioPicker,
        VueEditor
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propCategory: {
            type: Object,
            default: () => ({ empty: true })
        },
        propEvent: {
            type: Object,
            default: () => ({ empty: true })
        },
        propParent: {
            type: Object,
            default: () => ({ empty: true })
        },
        propStudent: {
            type: Object,
            default: () => ({ empty: true })
        },
        propTeacher: {
            type: Object,
            default: () => ({ empty: true })
        },
        propCalendar: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
            context: {}
        }
    },
    emits: ['close-modal', 'submit', 'show-modal', 'click-refresh'],
    setup(props, { emit }) {
        const isLoading = ref(false)
        const titleStack = ref(['Admin', 'Forms'])
        const router = useRouter()
        const toast = useToast()
        const str = useStore()
        const { categoryList } = getCategoryList()
        const userLogin = localStorage.getItem('username')
        const errors = ref([])
        const comboards = reactive({
            id: '',
            show_date: '',
            is_priority: false,
            comboard_category_id: '',
            info: '',
            is_event: '',
            datetime_1: '',
            datetime_2: '',
            to_parent: '',
            to_teacher: '',
            to_student: '',
            to_employee: '',
            add_to_calendar: '',
            is_recalled: false,
            recall_time: '',
            link_url: '',
            reason: '',
            created_by: '',
            updated_by: '',
            title: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_event: [1],
            file: null
        })
        const customElementsFormParent = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            to_parent: [1],
            file: null
        })
        const customElementsFormStudent = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            to_student: [1],
            file: null
        })
        const customElementsFormCalendar = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            add_to_calendar: [1],
            file: null
        })
        const customElementsFormTeacher = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            to_teacher: [1],
            file: null
        })
        const customElementsFormEmployee = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            to_employee: [1],
            file: null
        })

        const reset = () => {
            comboards.show_date = ''
            comboards.is_priority = false
            comboards.comboard_category_id = ''
            comboards.info = ''
            comboards.datetime_1 = ''
            comboards.datetime_2 = ''
            comboards.to_parent = ''
            comboards.to_teacher = ''
            comboards.to_student = ''
            comboards.to_employee = ''
            comboards.add_to_calendar = ''
            comboards.is_recalled = false
            comboards.recall_time = dateNow.value
            comboards.reason = ''
            comboards.link_url = ''
            comboards.title = ''
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'comboard-header/' + comboards.id : 'comboard-header'
            const method = props.showEdit ? 'PUT' : 'POST'
            if (method === 'POST') {
                comboards.created_by = userLogin
            } else {
                comboards.updated_by = userLogin
            }

            comboards.is_event = customElementsForm.is_event
            comboards.to_parent = customElementsFormParent.to_parent
            comboards.to_teacher = customElementsFormTeacher.to_teacher
            comboards.to_student = customElementsFormStudent.to_student
            comboards.to_employee = customElementsFormEmployee.to_employee
            comboards.add_to_calendar = customElementsFormCalendar.add_to_calendar

            if (Array.isArray(customElementsForm.is_event) === true) {
                if (customElementsForm.is_event[0] === '1' || customElementsForm.is_event[0] === 1) {
                    comboards.is_event = customElementsForm.is_event[0]
                } else {
                    comboards.is_event = false
                }
            } else {
                comboards.is_event = customElementsForm.is_event
            }
            if (Array.isArray(customElementsFormParent.to_parent) === true) {
                if (customElementsFormParent.to_parent[0] === '1' || customElementsFormParent.to_parent[0] === 1) {
                    comboards.to_parent = customElementsFormParent.to_parent[0]
                } else {
                    comboards.to_parent = false
                }
            } else {
                comboards.to_parent = customElementsFormParent.to_parent
            }
            if (Array.isArray(customElementsFormStudent.to_student) === true) {
                if (customElementsFormStudent.to_student[0] === '1' || customElementsFormStudent.to_student[0] === 1) {
                    comboards.to_student = customElementsFormStudent.to_student[0]
                } else {
                    comboards.to_student = false
                }
            } else {

                comboards.to_student = customElementsFormStudent.to_student
            }
            if (Array.isArray(customElementsFormTeacher.to_teacher) === true) {
                if (customElementsFormTeacher.to_teacher[0] === '1' || customElementsFormTeacher.to_teacher[0] === 1) {
                    comboards.to_teacher = customElementsFormTeacher.to_teacher[0]
                } else {
                    comboards.to_teacher = false
                }
            } else {

                comboards.to_teacher = customElementsFormTeacher.to_teacher
            }
            if (Array.isArray(customElementsFormEmployee.to_employee) === true) {
                if (customElementsFormEmployee.to_employee[0] === '1' || customElementsFormEmployee.to_employee[0] === 1) {
                    comboards.to_employee = customElementsFormEmployee.to_employee[0]
                } else {
                    comboards.to_employee = false
                }
            } else {
                comboards.to_employee = customElementsFormEmployee.to_employee
            }
            if (Array.isArray(customElementsFormCalendar.add_to_calendar) === true) {
                if (customElementsFormCalendar.add_to_calendar[0] === '1' || customElementsFormCalendar.add_to_calendar[0] === 1) {
                    comboards.add_to_calendar = customElementsFormCalendar.add_to_calendar[0]
                } else {
                    comboards.add_to_calendar = false
                }
            } else {
                comboards.add_to_calendar = false
            }

            if (Array.isArray(customElementsForm.is_event) === true) {
                if (customElementsForm.is_event[0] === '1' || customElementsForm.is_event[0] === 1 || comboards.is_event === true) {
                    comboards.datetime_1 = comboards.datetime_1
                }
            }
            if (Array.isArray(customElementsForm.is_event) === true) {
                if (customElementsForm.is_event[0] === '1' || customElementsForm.is_event[0] === 1 || comboards.is_event === true) {
                    comboards.datetime_2 = comboards.datetime_2
                }
            }

            const cutoff_posting = new Date(comboards.recall_time)
            const month_posting = (cutoff_posting.getMonth() + 1)
            const day_posting = cutoff_posting.getDate()
            const year_posting = cutoff_posting.getFullYear()
            const hours_posting = cutoff_posting.getHours()
            const minutes_posting = cutoff_posting.getMinutes()
            const postTime = year_posting + '-' + month_posting + '-' + day_posting + ' ' + hours_posting + ':' + minutes_posting
            comboards.recall_time = postTime
            if (postTime.includes('NaN')) {
                comboards.recall_time = null
            }

            console.log('comboards', comboards)

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            };
            if (props.showEdit) {
                axios.put(url, comboards, config)
                    .then(response => {
                        if (response.data.success) {
                            emit('close-modal')
                            emit('show-modal', response.data.get, response.data.data)
                            emit('click-refresh')
                            toast.success(response.data.message)
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        isLoading.value = false
                        reset()
                    })
                    .catch(error => {
                        if (error.response) {
                            console.log(error)
                            toast.error(error.response.data.message)
                            console.log(JSON.stringify(error.request))
                        } else if (error.message) {
                            console.log(error.message)
                            toast.error(error.message)
                            console.log(JSON.stringify(error.message))
                        }
                        isLoading.value = false
                    })
            } else {
                axios.post(url, comboards, config)
                    .then(response => {
                        if (response.data.success) {
                            emit('close-modal')
                            emit('show-modal', response.data.get, response.data.data)
                            emit('click-refresh')
                            toast.success(response.data.message)
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        isLoading.value = false
                        reset()
                    })
                    .catch(error => {
                        if (error.response) {
                            console.log(error)
                            toast.error(error.response.data.message)
                            console.log(JSON.stringify(error.request))
                        } else if (error.message) {
                            console.log(error.message)
                            toast.error(error.message)
                            console.log(JSON.stringify(error.message))
                        }
                        isLoading.value = false
                    })
            }
        }
        onBeforeMount(() => {
        })
        onMounted(() => {
            getDate()
        })
        watch(() => props.propClass, (newVal, oldVal) => { })
        watchEffect(() => {
            const newComboards = props.propClass

            if (newComboards.is_event !== undefined) {
                if (newComboards.is_event === false) {
                    customElementsForm.is_event = undefined
                }
            }

            if (newComboards.to_parent !== undefined) {
                if (newComboards.to_parent === false) {
                    customElementsFormParent.to_parent = undefined
                }
            }
            if (newComboards.to_student !== undefined) {
                if (newComboards.to_student === false) {
                    customElementsFormStudent.to_student = undefined
                }
            }
            if (newComboards.to_teacher !== undefined) {
                if (newComboards.to_teacher === false) {
                    customElementsFormTeacher.to_teacher = undefined
                }
            }
            if (newComboards.to_employee !== undefined) {
                if (newComboards.to_employee === false) {
                    customElementsFormEmployee.to_employee = undefined
                }
            }
            if (newComboards.add_to_calendar !== undefined) {
                if (newComboards.add_to_calendar === false) {
                    customElementsFormCalendar.add_to_calendar = undefined
                }
            }
            Object.assign(comboards, newComboards)

            if (newComboards.is_recalled == '') {
                comboards.is_recalled = false
            }
            if (newComboards.is_priority == '') {
                comboards.is_priority = false
            }
            if (newComboards.recall_time == '') {
                comboards.recall_time = dateNow.value
            }
        })

        const dateNow = ref('')
        const getDate = () => {
            var MyDate = new Date();
            var time = ('0' + MyDate.getHours()).slice(-2) + ":" + ('0' + MyDate.getMinutes()).slice(-2);

            dateNow.value = MyDate.getFullYear() + '-'
                + ('0' + (MyDate.getMonth() + 1)).slice(-2) + '-'
                + ('0' + MyDate.getDate()).slice(-2) + ' '
                + (time);
        }
        return {
            dateNow,
            getDate,
            isLoading,
            titleStack,
            categoryList,
            customElementsForm,
            customElementsFormParent,
            customElementsFormStudent,
            customElementsFormCalendar,
            customElementsFormTeacher,
            customElementsFormEmployee,
            getCategoryList,
            router,
            comboards,
            store,
            toast,
            userLogin,
            errors,
            reset,
            str,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
            ],
        }
    },
    method: {
        clearForm() {
            this.comboards = reactive({
                id: '',
                is_priority: '',
                show_date: '',
                comboard_category_id: '',
                info: '',
                is_event: '',
                datetime_1: '',
                datetime_2: '',
                to_parent: '',
                to_teacher: '',
                to_student: '',
                to_employee: '',
                add_to_calendar: '',
                is_recalled: '',
                recall_time: '',
                reason: '',
                link_url: '',
                created_by: '',
                title: ''
            })
        }
    },
    created() { }
}
</script>